import { putFrame, countFrames } from './db';

let frameCounter = null;
let currentSessionKey = null;
const queue = [];
let busy = false;

const ric =
  typeof window !== 'undefined' && window.requestIdleCallback
    ? window.requestIdleCallback.bind(window)
    : (cb) => setTimeout(() => cb({ timeRemaining: () => 0, didTimeout: true }), 0);

const drain = async () => {
  if (busy) return;
  busy = true;
  try {
    while (queue.length) {
      const item = queue.shift();
      await putFrame(item);
    }
  } catch (err) {
    console.warn('[timelapse] put failed', err);
  } finally {
    busy = false;
  }
};

const ensureCounter = async (guid, date) => {
  const key = `${guid}|${date}`;
  if (currentSessionKey === key && frameCounter !== null) return;
  currentSessionKey = key;
  frameCounter = await countFrames(guid, date);
};

export const resetCaptureState = () => {
  frameCounter = null;
  currentSessionKey = null;
  queue.length = 0;
};

export const captureTimelapseFrame = (mainCanvas, guid, date) => {
  if (!mainCanvas || !guid || !date) return;

  const w = mainCanvas.width;
  const h = mainCanvas.height;
  if (!w || !h) return;

  ric(
    () => {
      try {
        mainCanvas.toBlob(
          async (blob) => {
            if (!blob) {
              console.warn('[timelapse] toBlob returned null');
              return;
            }
            await ensureCounter(guid, date);
            const frameIndex = frameCounter++;
            queue.push({ guid, date, frameIndex, blob, w, h });
            drain();
          },
          'image/webp',
          0.8
        );
      } catch (err) {
        console.warn('[timelapse] capture failed', err);
      }
    },
    { timeout: 500 }
  );
};
